import axios from 'axios';

// 创建一个axios实例
const service = axios.create({
    baseURL:"", // url = base url + request url
    withCredentials: false, // send cookies when cross-domain requests
    timeout: 10000 // request timeout 10s
});

// 请求拦截器
service.interceptors.request.use(config => {
    // do something before request is sent
    return config;
},error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error);
});

// 响应拦截器
service.interceptors.response.use(response => {
    //do something before response
    if (response.status >= 200 && response.status <= 210) {
        return response.data;
    } else {
        //不走
    }
},
error => {
    console.log('err' + error); // for debug
    return Promise.reject(error);
})

export default service;